import React, { useState } from 'react';
import Editor from '@monaco-editor/react';
import "../CodeConverter.css";
import { FaDownload, FaCompress, FaBrush, FaCopy, FaCheck, FaTrash } from "react-icons/fa";
import JsonEditorPanel from "../components/JsonEditorPanel";
import CommonSeoContent from "../components/CommonSeoContent";
import useEditorActions from "../utils/useEditorActions";

const JsonToPhp = () => {
  const [inputCode, setInputCode] = useState("");
  const [outputCode, setOutputCode] = useState("");

  // Import reusable actions
  const { handleDownload, handleClear } = useEditorActions(
    setInputCode,
    outputCode,
    setOutputCode
  );


  const toPhpClass = (name, obj, indent = '') => {
    let classLines = [`${indent}class ${name} {`];
    let nestedClasses = [];

    for (const key in obj) {
      const value = obj[key];
      const propName = `$${key}`;

      if (value && typeof value === 'object' && !Array.isArray(value)) {
        const className = name + '_' + capitalize(key);
        classLines.push(`${indent}  public ${className} ${propName};`);
        nestedClasses.push(toPhpClass(className, value, indent));
      } else {
        classLines.push(`${indent}  public ${propName}; // ${typeof value}`);
      }
    }

    classLines.push(`${indent}}`);
    return [...nestedClasses, ...classLines].join('\n');
  };

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const handleConvert = () => {
    try {
      const json = JSON.parse(inputCode);
      if (typeof json !== 'object') throw new Error('Invalid root JSON object.');
      const phpClass = toPhpClass('MyClass', json);
      setOutputCode(phpClass);
    } catch (e) {
      setOutputCode("// ❌ Invalid JSON:\n" + e.message);
    }
  };

    return (
      <div className="formatter-container">
        <h1>JSON ➝ Php Converter </h1>

        {/* Toolbar */}
        <div className="toolbar">
          <button onClick={handleConvert} className="btn primary">
            <FaBrush /> Convert
          </button>
          <button onClick={() => handleDownload("php", "formatted")} className="btn success">
            <FaDownload /> Download
          </button>
  		<button onClick={handleClear} className="btn danger">
            <FaTrash /> Clear
          </button>

        </div>

        {/* Editors */}
        <div className="editor-panels">
          <JsonEditorPanel title="Input JSON" language="json" code={inputCode} setCode={setInputCode} />
          <div className="editor-section-empty-div">
          </div>
          <JsonEditorPanel title="Output Php" language="php"  code={outputCode} />
        </div>
		
		<CommonSeoContent
  title="Online JSON to PHP Array Converter"
  description="Convert JSON data into PHP associative arrays or objects with jsonconverter.org. Supports nested JSON and produces clean, readable PHP code."
  keywords="JSON to PHP, json to php array, json to php object, php code generator, json to php converter, online php converter, jsonconverter.org"
  author="jsonconverter.org"
  heading="Why Use JSON to PHP Converter?"
  whyUseText="Our JSON to PHP Converter allows you to quickly transform complex JSON data into well-structured PHP associative arrays or objects. Whether you're working with API responses, configuration files, or JSON payloads in web development, this tool eliminates the need for manual parsing or guesswork. It supports deeply nested structures and preserves key-value integrity. Since the entire process runs in your browser, your data stays secure and private. It’s fast, reliable, and designed specifically for developers working with PHP-based frameworks like Laravel, Symfony, or WordPress."
  howToUseSteps={[
    "Paste your JSON into the input editor.",
    "Click the Convert button.",
    "View your PHP array or object instantly.",
    "Copy or download the PHP code for use in your project.",
  ]}
  features={[
    "Converts JSON to clean PHP arrays or stdClass objects",
    "Handles nested JSON and complex data structures",
    "Produces valid PHP syntax for direct use",
    "Runs completely in-browser — your data stays secure",
    "No signup or installation required — fast and free",
    "Option to download the PHP output for reuse",
  ]}
  inputTitle="Input JSON:"
  inputExample={`{
  "name": "John Doe",
  "age": 30,
  "emails": ["john@example.com"],
  "isActive": true
}`}
  outputTitle="Output PHP:"
  outputExample={`$data = [
  "name" => "John Doe",
  "age" => 30,
  "emails" => ["john@example.com"],
  "isActive" => true
];`}
  callToAction="Start converting your JSON to PHP instantly — no signup required."
/>
      </div>
    );
};

export default JsonToPhp;
